module.exports = __webpack_public_path__ + "7b062c61c493224a1366ef889e6b2234.MP3";